import { useTranslation } from 'react-i18next';
import { ShieldCheck } from 'lucide-react';
import { LoginForm } from '../components/LoginForm';
import { LoginBrandPanel } from '../components/LoginBrandPanel';
import { PreAuthShell } from '@/shared/components/layout/PreAuthShell';

/**
 * Login surface (Surface 1 in docs/design/auth.md).
 * Two-panel split on ≥ lg viewports; single column on smaller.
 */
export function LoginPage() {
  const { t } = useTranslation('auth');

  return (
    <PreAuthShell variant="split" brandSlot={<LoginBrandPanel />} showBackToSite>
      <div className="space-y-6">
        <div className="space-y-2">
          <h1 className="font-extrabold tracking-tight text-3xl leading-tight">
            {t('login.welcomeBack')}
          </h1>
          <p className="text-sm text-muted-foreground">{t('login.welcomeBackSubtitle')}</p>
        </div>

        <div className="flex items-center justify-between text-xs text-muted-foreground">
          <span className="inline-flex items-center gap-1.5 font-mono uppercase tracking-wider text-emerald-500">
            <ShieldCheck className="h-3 w-3" />
            {t('login.mfaRequired')}
          </span>
        </div>

        <LoginForm />

        <p className="text-center text-xs text-muted-foreground">
          {t('login.enterpriseSso.prefix')}{' '}
          <a
            href="/help/sso"
            className="font-medium text-amber-500 hover:text-amber-400 hover:underline"
          >
            {t('login.enterpriseSso.cta')}
          </a>
        </p>
      </div>
    </PreAuthShell>
  );
}
